import { el } from '../../core/dom.js';
import { api } from '../../core/api.js';
import { navigate } from '../../core/router.js';
import {
  inviteAcceptPayload,
  parseAuthSearch,
  validateInvitePasswords,
} from './model.js';
import { authShell, errorBox, setError } from './layout.js';

/**
 * @param {{ search?: string }} [opts]
 */
export function renderAcceptInvite(opts) {
  const query = parseAuthSearch(opts && opts.search);
  const err = errorBox('');
  const success = el('div', { class: 'auth-success', hidden: true });
  const email = el('input', {
    class: 'auth-fld',
    type: 'email',
    name: 'email',
    value: query.email || '',
    readonly: true,
  });
  const password = el('input', {
    class: 'auth-fld',
    type: 'password',
    name: 'password',
    placeholder: 'Minimum 6 characters',
    required: true,
    autocomplete: 'new-password',
  });
  const confirm = el('input', {
    class: 'auth-fld',
    type: 'password',
    name: 'confirm',
    placeholder: 'Repeat your password',
    required: true,
    autocomplete: 'new-password',
  });

  const form = el('form', {
    class: 'auth-form',
    onSubmit: async (event) => {
      event.preventDefault();
      const invalid = validateInvitePasswords({
        password: password.value,
        confirm: confirm.value,
      });
      if (invalid) {
        setError(err, invalid);
        return;
      }
      setError(err, '');
      const body = inviteAcceptPayload({
        token: query.token,
        email: email.value,
        password: password.value,
      });
      const data = await api('/auth/accept-invite', { method: 'POST', body });
      if (data && data.error) {
        setError(err, data.error);
        return;
      }
      form.hidden = true;
      success.hidden = false;
      success.replaceChildren(
        el('h3', null, 'Account Activated!'),
        el('p', null, (data && data.message) || 'You can sign in with your email and password.'),
        el('button', {
          type: 'button',
          class: 'auth-go',
          onClick() { navigate('/app/login'); },
        }, 'Go to Sign In'),
      );
    },
  },
  el('label', { class: 'auth-field' },
    el('span', { class: 'lbl auth-field-lbl' }, 'Email'), email),
  el('label', { class: 'auth-field' },
    el('span', { class: 'lbl auth-field-lbl' }, 'Password'), password),
  el('label', { class: 'auth-field' },
    el('span', { class: 'lbl auth-field-lbl' }, 'Confirm Password'), confirm),
  el('div', { class: 'auth-cta' },
    el('button', { type: 'submit', class: 'auth-go' },
      'Activate Account ', el('span', { class: 'auth-arw' }, '→'))),
  el('p', { class: 'auth-alt' },
    'Already have an account? ',
    el('a', {
      href: '/app/login',
      class: 'auth-lnk',
      onClick(event) {
        event.preventDefault();
        navigate('/app/login');
      },
    }, 'Sign in')));

  if (query.token && query.email) {
    api(`/auth/verify-invite?token=${encodeURIComponent(query.token)}&email=${encodeURIComponent(query.email)}`)
      .then((data) => {
        if (!data || data.error || data.valid === false) {
          setError(err, 'This invite link is invalid or expired.');
          form.hidden = true;
        }
      })
      .catch(() => {});
  }

  return authShell({
    kicker: '✦ Invite',
    title: 'Accept ',
    titleEm: 'invitation.',
    lead: 'Set your password to activate your account.',
    error: err,
    children: [form, success],
  });
}
